import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideCruds } from './crud-service.provider';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [],
})
export class CrudModule {
    static forRoot(models: Record<string, any>): ModuleWithProviders<CrudModule> {
        return {
            ngModule: CrudModule,
            providers: provideCruds(Object.keys(models).map(k => models[k]))
        };
    }
}
